// Copied from the legacy user app (sussd5-apply .../apply/applicant/diagnosedConditions.js), itself from sussd-mono
// Optional applicability flags on a group (absent means "everyone"):
//   sex: 'female' | 'male'                    - only asked of that sex
//   minAge / maxAge                           - only asked within that age range
//   seriousIllnessOrIncomeProtectionOnly: true - only asked when applying for
//                                                serious illness or income protection
export const diagnosedConditionGroups = [
    {
        file: 'cysts-growths-lumps-tumours.pdf',
        title: 'Cancer, Cysts, Growths, Lumps and Tumours',
        description: "Cancer, cancer-in-situ, leukaemia, Hodgkin's disease, or any other tumour, growth, lump or cyst (whether seen by a doctor or not).",
    },
    {
        file: 'raised_cholesterol.pdf',
        title: 'Raised Cholesterol',
        description: 'Raised cholesterol.',
    },
    {
        file: 'drug_use.pdf',
        title: 'Drug Use',
        description: 'Drug use.',
    },
    {
        file: 'epilepsy.pdf',
        title: 'Epilepsy',
        description: 'Grand mal epilepsy, petit mal epilepsy, nocturnal epilepsy, absence epilepsy, or other epilepsy.',
    },
    {
        file: 'gastric_and_intestinal_disorders.pdf',
        title: 'Gastric or Intestinal Disorders',
        description: "Peptic ulcer, duodenal ulcer, Crohn's disease, ulcerative colitis, IBS, reflux, coeliac disease, heartburn, or anything else affecting your stomach, bowel or digestive system.",
    },
    {
        file: 'arthritis-general_joint_disorders.pdf',
        seriousIllnessOrIncomeProtectionOnly: true,
        title: 'Joint Disorders',
        description: 'Rheumatoid arthritis, osteoarthritis, gout, ankylosing spondylitis, fibromyalgia, or other general joint disorder.',
    },
    {
        file: 'back_disorders.pdf',
        seriousIllnessOrIncomeProtectionOnly: true,
        title: 'Back Disorders',
        description: 'Lower back pain, slipped disc, sciatica, or other back disorder.',
    },
    {
        file: 'diabetes.pdf',
        title: 'Diabetes',
        description: 'Insulin dependent diabetes, non-insulin dependent diabetes, or raised blood sugar.',
    },
    {
        file: 'gynaecological_disorders.pdf',
        sex: 'female',
        title: 'Gynaecological Problems',
        description: 'Abnormal smear, hysterectomy, or other gynaecological problem.',
    },
    {
        file: 'thyroid_disorders.pdf',
        title: 'Thyroid Disorders',
        description: 'Hypothyroidism, hyperthyroidism, goitre, thyroid nodule, or other thyroid disorder.',
    },
    {
        file: 'respiratory_disorders.pdf',
        title: 'Respiratory Disorders',
        description: 'Asthma, chronic bronchitis, chronic obstructive airways disease, emphysema, pulmonary tuberculosis, bronchiectasis, obstructive sleep apnoea, or other respiratory disorder.',
    },
    {
        file: 'raised_blood_pressure.pdf',
        title: 'Raised Blood Pressure',
        description: 'Raised blood pressure.',
    },
    {
        file: 'kidney_and_urinary_disorders.pdf',
        title: 'Kidney or Urinary Disorders',
        description: 'Kidney stones, renal colic, nephritis, urinary infection, or anything else affecting your kidneys, prostate, bladder or urine.',
    },
    {
        file: 'anxiety-stress-depression.pdf',
        title: 'Anxiety, Stress and Depression',
        description: 'Anxiety, stress, or depression.',
    },
    // Groups below have no Royal London questionnaire PDF of their own -
    // they're here so the condition is captured at all; details go in
    // diagnosedConditionsDetails rather than a downloaded questionnaire.
    {
        value: 'heart',
        title: 'Heart Conditions',
        description: 'Heart attack, chest pain, irregular heart beat, cardiomyopathy, valve disorder, or any other heart condition or heart surgery.',
    },
    {
        value: 'stroke-brain',
        title: 'Stroke or Brain Conditions',
        description: 'Stroke, TIA, brain haemorrhage, or damage or surgery to your brain.',
    },
    {
        value: 'serious-mental-illness',
        title: 'Serious Mental Illness',
        description: 'Bipolar disorder, manic depression, schizophrenia, psychosis, or eating disorder.',
    },
    {
        value: 'self-harm',
        title: 'Self Harm',
        description: 'Tried to take your own life, intentionally harmed yourself, or had thoughts of either.',
    },
    {
        value: 'neurological',
        maxAge: 54,
        title: 'Nervous System Disorders',
        description: "Multiple sclerosis, Parkinson's disease, or any other disorder of the brain or nervous system.",
    },
    {
        value: 'dementia',
        minAge: 55,
        title: 'Dementia',
        description: "Alzheimer's disease or any other form of dementia.",
    },
    {
        value: 'hiv-hepatitis',
        title: 'HIV or Hepatitis',
        description: 'A positive test, or waiting on the results of a test, for HIV, AIDS, or Hepatitis B or C.',
    },
    {
        value: 'covid-hospitalisation',
        title: 'COVID-19 Hospitalisation',
        description: 'Hospitalisation due to COVID-19.',
    },
    {
        value: 'blood-disorders',
        title: 'Blood Disorders',
        description: 'Anaemia, blood clot, or anything else affecting your blood.',
    },
    {
        value: 'liver-pancreas',
        title: 'Liver or Pancreas Disorders',
        description: 'Anything affecting your liver or pancreas.',
    },
    {
        value: 'numbness-coordination',
        seriousIllnessOrIncomeProtectionOnly: true,
        title: 'Numbness or Co-ordination Problems',
        description: 'Numbness, pins and needles, muscle weakness, tremor, or difficulty with co-ordination.',
    },
    {
        value: 'ears-balance',
        seriousIllnessOrIncomeProtectionOnly: true,
        title: 'Ear, Hearing or Balance Disorders',
        description: 'Tinnitus, labyrinthitis, or anything else affecting your ears, hearing or balance.',
    },
    {
        value: 'eyes-vision',
        seriousIllnessOrIncomeProtectionOnly: true,
        title: 'Eye or Vision Disorders',
        description: 'Impaired, blurred or double vision, optic neuritis, or anything else affecting your eyes.',
    },
    {
        value: 'chronic-fatigue',
        seriousIllnessOrIncomeProtectionOnly: true,
        title: 'Chronic Fatigue',
        description: 'Chronic fatigue syndrome, ME, fibromyalgia, or persistent tiredness.',
    },
    {
        value: 'other',
        title: 'Other',
        description: 'Any other diagnosed condition.',
    },
    {
        value: 'none',
        title: 'No',
        description: 'No diagnosed medical conditions.',
        exclusive: true,
    },
].map(it => ({
    ...it,
    // Every group gets a stable, short `value` key - the file name minus
    // its extension for anything with a `file` ('epilepsy.pdf' ->
    // 'epilepsy'), or whatever `value` was already hand-set ('other',
    // 'none') for the two that have no file at all. A selection is this
    // short key, never a full S3 link.
    value: it.value ?? it.file.replace(/\.pdf$/, ''),
    url: it.file ? `https://sussd-public-documents.s3.eu-west-1.amazonaws.com/health-questionnaires/royal-london-ireland/${it.file}` : null,
}))
